import { i as f, x as l, s as m } from "../../lit-element-6iugfgmM.js";
import { e as g } from "../../custom-element-wk-AooBb.js";
import { n } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import { axesToFontVariationSettings as d, getCSSBlock as u } from "../../lib/CSS.js";
import { Localize as h } from "../../lib/I18N.js";
import "../display-in-font/DisplayInFont.js";
const v = { "variable-font-sample-card.axes-count": "{count, plural, =0 {0 Axes} =1 {1 Axis} other {# Axes}}" }, x = f`:host{--variable-font-sample-card-border-color: var(--spectrum-global-color-gray-200);--variable-font-sample-card-font-size: 30px;--variable-font-sample-card-hover-color: var(--spectrum-global-color-blue-400);border:1px solid var(--variable-font-sample-card-border-color);border-radius:2px;display:inline-block;min-width:180px}:host(:hover){border-color:var(--variable-font-sample-card-hover-color)}#specimens{display:flex;justify-content:space-around;margin:0;padding:5px 8px}.specimen{color:var(--spectrum-global-color-gray-700);font-size:var(--variable-font-sample-card-font-size);list-style:none;margin:8px}#footer{background:#fafafa;border-top:1px solid var(--variable-font-sample-card-border-color);color:var(--spectrum-global-color-gray-700);padding:4px 8px}:host(:hover) #footer{color:var(--spectrum-global-color-gray-50);background:var(--variable-font-sample-card-hover-color)}`;
var b = Object.defineProperty, y = Object.getOwnPropertyDescriptor, s = (e, t, o, i) => {
  for (var p, r = i > 1 ? void 0 : i ? y(t, o) : t, c = e.length - 1; c >= 0; c--) (p = e[c]) && (r = (i ? p(t, o, r) : p(r)) || r);
  return i && r && b(t, o, r), r;
};
let a = class extends h(m, v) {
  constructor() {
    super(...arguments), this.fontId = "", this.sampleString = "Ag", this.unicodeRange = "", this.featureSettings = "";
  }
  static get styles() {
    return x;
  }
  render() {
    if (this.fontData) return l`${this.renderSpecimens()} ${this.renderFooter()}`;
  }
  renderSpecimens() {
    return l`<ul id="specimens">${this.renderSpecimen(this._getMinAxisData())} ${this.renderSpecimen(this._getMidAxisData())} ${this.renderSpecimen(this._getMaxAxisData())}</ul>`;
  }
  renderSpecimen(e) {
    var t, o;
    return l`<style>${this.getCSSRules(".specimen", e)}</style><li class="specimen"><af-display-in-font fontVariationSettings="${d(e)}" fontStyle="${((t = this.fontData) == null ? void 0 : t.style) ?? "normal"}" fontWeight="${((o = this.fontData) == null ? void 0 : o.weight) ?? ""}" unicodeRange="${this.unicodeRange}" webId="${this.fontId}">${this.sampleString}</af-display-in-font></li>`;
  }
  renderFooter() {
    var e, t;
    return l`<div id="footer">${(e = this.fontData) == null ? void 0 : e.fontName}: ${this.t("variable-font-sample-card.axes-count", { count: (t = this.fontData) == null ? void 0 : t.axes.length })}</div>`;
  }
  setFontData(e) {
    this.fontData = e;
  }
  _getMaxAxisData() {
    var e;
    return ((e = this.fontData) == null ? void 0 : e.axes.map((t) => ({ tag: t.tag, value: t.max }))) ?? [];
  }
  _getMidAxisData() {
    var e;
    return ((e = this.fontData) == null ? void 0 : e.axes.map((t) => ({ tag: t.tag, value: t.min + (t.max - t.min) / 2 }))) ?? [];
  }
  _getMinAxisData() {
    var e;
    return ((e = this.fontData) == null ? void 0 : e.axes.map((t) => ({ tag: t.tag, value: t.min }))) ?? [];
  }
  getCSSRules(e, t) {
    return u(e, { "font-feature-settings": this.featureSettings, "font-variation-settings": d(t) });
  }
};
s([n()], a.prototype, "fontData", 2), s([n()], a.prototype, "fontId", 2), s([n()], a.prototype, "sampleString", 2), s([n()], a.prototype, "unicodeRange", 2), s([n()], a.prototype, "featureSettings", 2), a = s([g("af-variable-font-sample-card")], a);
const k = a;
export {
  k as default
};
//# sourceMappingURL=VariableFontSampleCard.js.map
